import { ChevronIcon } from "../icon";

export default function PreviousPaginationButton() {
  return (
    <button className="bg-black w-8 h-8 rounded-[4px] flex items-center justify-center !text-white">
      <ChevronIcon />
    </button>
  );
}
